import { TFunction } from "i18next";
import * as yup from "yup";

export const editOrganizationSchema = (errorsT: TFunction) =>
  yup.object({
    name: yup.string().required(errorsT("required")),
    email: yup.string().email(errorsT("string.email")).required(errorsT("required"))
  });
